import { SportEvent } from "@fresh8/types/src/betData";
import { enabledH2HSizes } from "@fresh8/types/src/featureFlags";
import { Sport } from "@fresh8/types/src/language";
import {
  MAIN_MARKET_GROUP,
  WDW_GROUP,
  WW_GROUP
} from "../../../../constants/market-types";
import { MarketCard, EventGroup, CreationContext } from "../../types";

function sumValues(object: Record<string, any>): number {
  return Object.values(object).reduce((a: number, c: string | number) => {
    // convert c to number incase its string
    return a + Number(c);
  }, 0);
}

const H2HFilterMap = {
  Football: (event: SportEvent) => {
    const home = event?.competitors?.home;
    const away = event?.competitors?.away;

    const homeHasForm = !!home.form && home.form.length > 0;
    const awayHasForm = !!away.form && away.form.length > 0;
    const homeHasStats = !!home.statistics && sumValues(home.statistics) > 0;
    const awayHasStats = !!away.statistics && sumValues(away.statistics) > 0;

    return homeHasForm && awayHasForm && homeHasStats && awayHasStats;
  },
  Baseball: (event: SportEvent) => {
    const home = event?.competitors?.home;
    const away = event?.competitors?.away;

    const homeStats = home?.statistics_baseball;

    const record = homeStats?.record;

    const H_battingStats = sumValues(homeStats?.batting_stats || {});
    const H_generalStats = sumValues(homeStats?.general_stats || {});
    const H_pitchingStats = sumValues(homeStats?.pitching_stats || {});

    const awayStats = away?.statistics_baseball;

    const A_battingStats = sumValues(awayStats?.batting_stats || {});
    const A_generalStats = sumValues(awayStats?.general_stats || {});
    const A_pitchingStats = sumValues(awayStats?.pitching_stats || {});

    return (
      !!homeStats &&
      !!awayStats &&
      !!record &&
      ((!!H_battingStats && !!A_battingStats) ||
        (!!H_generalStats && !!A_generalStats) ||
        (!!H_pitchingStats && !!A_pitchingStats))
    );
  },
  "American Football": (event: SportEvent) => {
    const home = event?.competitors?.home;
    const away = event?.competitors?.away;

    const homeStats = home?.statistics_american_football;

    const record = homeStats?.record;

    const H_passingStats = sumValues(homeStats?.passing_stats || {});
    const H_generalStats = sumValues(homeStats?.general_stats || {});
    const H_rushingStats = sumValues(homeStats?.rushing_stats || {});

    const awayStats = away?.statistics_american_football;

    const A_passingStats = sumValues(awayStats?.passing_stats || {});
    const A_generalStats = sumValues(awayStats?.general_stats || {});
    const A_rushingStats = sumValues(awayStats?.rushing_stats || {});

    return (
      !!homeStats &&
      !!awayStats &&
      !!record &&
      ((!!H_passingStats && !!A_passingStats) ||
        (!!H_generalStats && !!A_generalStats) ||
        (!!H_rushingStats && !!A_rushingStats))
    );
  }
};

function h2hGuard(sport: Sport, event: SportEvent) {
  const filter = H2HFilterMap[sport];
  if (!filter) return false;

  return filter(event);
}

export function createH2HCard(
  event: EventGroup,
  context: CreationContext
): Array<MarketCard> {
  if (!enabledH2HSizes.includes(context.size.name.toLocaleLowerCase()))
    return [];

  const h2hMarkets = event.data.markets;

  if (!h2hMarkets || !h2hGuard(event.sport, event.data)) return [];

  const h2hCard = new MarketCard({
    type: "h2h",
    eventId: event.id,
    marketIds: h2hMarkets,
    optionIds: null
  });

  return [h2hCard];
}
